export const colors = {
	primary500: '#1570EF',
	gray600: '#5D6679',
	gray800: '#383E49',
};

export const listColors = [
	'coral',
	'magenta',
	'red',
	'volcano',
	'orange',
	'gold',
	'lime',
	'green',
	'cyan',
	'blue',
	'geekblue',
	'purple',
];
